import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
import { locales } from '../../translations/translations';
export const ASSET_NAME = 'terms-of-service';

export const loadData = (params, search) => dispatch => {
  const localizedAssetName = locales.includes(params.lang) ? `${ASSET_NAME}-${params.lang}` : ASSET_NAME
  const pageAsset = { termsOfService: `content/pages/${localizedAssetName}.json` };
  return dispatch(fetchPageAssets(pageAsset, true));
};
